var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home-cards"}},[_c('vue-scroll',{ref:"vs",attrs:{"ops":_vm.cx_vueScrollOption}},[_c('b-row',{staticClass:"d-flex flex-nowrap appointment-cards"},_vm._l((_vm.cx_cards),function(card,index){return _c('card-item',{key:index,class:{
          'ms-0 cards-spacing': index === 0,
          'cards-spacing': index !== 0,
          'me-4': index === _vm.cx_cards.length - 1,
        },attrs:{"title":card.title,"image":card.image,"value":card.value,"url":card.link,"code":card.code}})}),1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }